import React from 'react'

export default function ItemHomeCliente({ image }) {
    return (
        <img src={image} style={{
            verticalAlign: "middle",
            margin: "0.5em",
            boxShadow: "0px 4px 10px 0px grey"
        }} />
    )
}
